const { notEmptyValidator } = require('@/views/fusion/investment/intelligence-create/tools/form/validator');

const campaign_name = {
  label: '计划名称',
  type: 'input',
  rules: [
    {
      required: true,
      message: '请输入计划名称',
      trigger: ['change'],
      validator: notEmptyValidator,
    },
  ],
  word_list: ['定向包名称'],
  props: {
    placeholder: '请输入计划名称',
  },
  value: '',
  isPreview: false,
};

const fusion__campaign_num = {
  label: '新建广告数',
  type: 'radio-group',
  isButton: true,
  rules: {
    required: true,
    message: '请选择新建广告数',
    trigger: ['change'],
  },
  options: [
    {
      label: '按渠道数',
      value: 'channel_num',
    },
  ],
  value: 'channel_num',
};

const is_label = {
  label: '素材标签',
  type: 'radio-group',
  isButton: true,
  props: {
    disabled: true,
  },
  options: [
    { label: '使用', value: 1 },
    { label: '不使用', value: 0 },
  ],
  value: 0,
};

const labels = {
  label: ' ',
  type: '',
  hidden: true,
  is_open: false,
  isPreview: false,
  rules: {
    required: true,
    trigger: ['change'],
    validator: (_, value, callback) => {
      if (Object.keys(value).length && Object.values(value).every(item => item?.length)) {
        callback();
      } else {
        callback(new Error('请选择素材标签'));
      }
    },
  },
  // 临时分配
  assignSelection: {},
  // 格式 - { [advertiser_id]: [{}, {}] }
  value: {},
  formItemTips: {
    props: {
      class: 'color-red',
    },
    content: '使用标签将无法选择素材，默认使用标签关联素材进行创建',
  },
};

/**
 * 广告：基础配置
 */
export {
  campaign_name, // 计划名称
  fusion__campaign_num, // 新建广告数
  is_label, // 素材标签选项
  labels, // 素材标签
};
